export const USER_STATUS = Object.freeze({ INVITED: 'invited', ACTIVE: 'active', DISABLED: 'disabled' });
export const DEVICE_STATUS = Object.freeze({ ACTIVE: 'active', REVOKED: 'revoked' });
export const EMAIL_STATUS = Object.freeze({
  PENDING: 'pending',
  SENDING: 'sending',
  SENT: 'sent',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
});
export const EMAIL_STATUS_LIST = Object.values(EMAIL_STATUS);

/**
 * The order queued emails go out in, lowest first. With a daily limit (MAIL_MAX_PER_DAY), account
 * emails still go out once it is reached; campaigns stop at their share of it (MAIL_CAMPAIGN_SHARE).
 */
export const EMAIL_PRIORITY = Object.freeze({
  ACCOUNT: 0, // sign-in links and password alerts: someone can't get in without them
  NOTICE: 1, // licence, security and data notices, and emails someone just asked for
  REPORT: 2, // scheduled reports: daily summary, Z report, low stock
  CAMPAIGN: 3, // marketing to customers
});
const P = EMAIL_PRIORITY;
/** Every email template and its priority. */
export const EMAIL_TEMPLATES = Object.freeze({
  welcome: P.ACCOUNT,
  'set-password': P.ACCOUNT,
  'forgot-password': P.ACCOUNT,
  'password-changed': P.ACCOUNT,
  'license-expiry-reminder': P.NOTICE,
  'license-expired': P.NOTICE,
  'account-suspended': P.NOTICE,
  'account-reactivated': P.NOTICE,
  'data-deletion-notice': P.NOTICE,
  'data-export-ready': P.NOTICE,
  'api-key-created': P.NOTICE,
  'api-key-rotated': P.NOTICE,
  'device-registered': P.NOTICE,
  'e-receipt': P.NOTICE,
  'admin-test': P.NOTICE,
  'daily-summary': P.REPORT,
  'z-report': P.REPORT,
  'low-stock': P.REPORT,
  campaign: P.CAMPAIGN,
});
export const EMAIL_TEMPLATE_LIST = Object.keys(EMAIL_TEMPLATES);
export const ANNOUNCEMENT_SEVERITY = Object.freeze(['info', 'warning', 'critical']);

export const DEFAULT_LOCALE = Object.freeze({
  country: 'IN',
  currency: 'INR',
  timezone: 'Asia/Kolkata',
  language: 'en',
});

export const DEFAULT_DAY_CUTOFF_MINUTES = 240; // 04:00

/** A device counts as "online" if it sent a heartbeat within this window. */
export const DEVICE_ONLINE_WINDOW_MS = 2 * 60 * 1000;
export const DEVICE_HEARTBEAT_INTERVAL_MS = 60 * 1000;

export const LANGUAGES = Object.freeze([
  { code: 'en', label: 'English' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'te', label: 'తెలుగు' },
]);

/** GST state codes (used for CGST/SGST vs IGST decisions in later phases). */
export const INDIAN_STATES = Object.freeze([
  { code: '01', name: 'Jammu and Kashmir' },
  { code: '02', name: 'Himachal Pradesh' },
  { code: '03', name: 'Punjab' },
  { code: '04', name: 'Chandigarh' },
  { code: '05', name: 'Uttarakhand' },
  { code: '06', name: 'Haryana' },
  { code: '07', name: 'Delhi' },
  { code: '08', name: 'Rajasthan' },
  { code: '09', name: 'Uttar Pradesh' },
  { code: '10', name: 'Bihar' },
  { code: '11', name: 'Sikkim' },
  { code: '12', name: 'Arunachal Pradesh' },
  { code: '13', name: 'Nagaland' },
  { code: '14', name: 'Manipur' },
  { code: '15', name: 'Mizoram' },
  { code: '16', name: 'Tripura' },
  { code: '17', name: 'Meghalaya' },
  { code: '18', name: 'Assam' },
  { code: '19', name: 'West Bengal' },
  { code: '20', name: 'Jharkhand' },
  { code: '21', name: 'Odisha' },
  { code: '22', name: 'Chhattisgarh' },
  { code: '23', name: 'Madhya Pradesh' },
  { code: '24', name: 'Gujarat' },
  { code: '26', name: 'Dadra and Nagar Haveli and Daman and Diu' },
  { code: '27', name: 'Maharashtra' },
  { code: '29', name: 'Karnataka' },
  { code: '30', name: 'Goa' },
  { code: '31', name: 'Lakshadweep' },
  { code: '32', name: 'Kerala' },
  { code: '33', name: 'Tamil Nadu' },
  { code: '34', name: 'Puducherry' },
  { code: '35', name: 'Andaman and Nicobar Islands' },
  { code: '36', name: 'Telangana' },
  { code: '37', name: 'Andhra Pradesh' },
  { code: '38', name: 'Ladakh' },
  { code: '97', name: 'Other Territory' },
]);
